import { createFileRoute, Outlet } from "@tanstack/react-router"
import LeadDocketGate from "@/components/coreLeadDocket/LeadDocketGate"

// Every /core/lead-docket page sits behind the gate: no flag, no connection or
// no permission each get their own screen instead of the page.
function LeadDocketRoute() {
  return (
    <LeadDocketGate>
      <Outlet />
    </LeadDocketGate>
  )
}

export const Route = createFileRoute("/core/lead-docket")({ component: LeadDocketRoute })
